import { render, staticRenderFns } from "./SubitemArea.vue?vue&type=template&id=eadbd46c"
import script from "./SubitemArea.vue?vue&type=script&lang=js"
export * from "./SubitemArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports